/** Compare — benefit grid: a stack of separate tools vs one Karexia platform. */

import { useT } from '@/i18n';
import { Icon, SectionHeading } from './shared';

const ROWS = ['r1', 'r2', 'r3', 'r4', 'r5', 'r6'] as const;

export function Compare() {
  const { t } = useT();
  return (
    <section id="comparatif" className="mx-auto w-full max-w-5xl px-4 pt-16 sm:px-6 sm:pt-20 lg:px-8 lg:pt-24">
      <SectionHeading eyebrow={t('routes.landing.v2.compare.eyebrow')} title={t('routes.landing.v2.compare.title')} />
      <div className="mt-10 overflow-hidden rounded-token-xl border border-border bg-surface shadow-elevation-2">
        <table className="w-full border-collapse text-left text-sm">
          <thead>
            <tr className="bg-surface-2/60">
              <th scope="col" className="px-4 py-3 font-semibold text-foreground">{t('routes.landing.v2.compare.colTopic')}</th>
              <th scope="col" className="px-4 py-3 font-semibold text-muted">{t('routes.landing.v2.compare.colBefore')}</th>
              <th scope="col" className="px-4 py-3 font-semibold text-primary">{t('routes.landing.v2.compare.colAfter')}</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((r) => (
              <tr key={r} className="border-t border-border align-top">
                <th scope="row" className="px-4 py-3 font-semibold text-foreground">{t(`routes.landing.v2.compare.${r}Topic`)}</th>
                <td className="px-4 py-3 text-muted">{t(`routes.landing.v2.compare.${r}Before`)}</td>
                <td className="px-4 py-3 text-foreground">
                  <span className="flex items-start gap-2">
                    <Icon name="check" className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" strokeWidth={2.4} />
                    <span>{t(`routes.landing.v2.compare.${r}After`)}</span>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
